<!-- 薪资发放 -->
<template>
    <section>
        <section class="search-container">
            <a-form layout="inline" class="m-t-14">
               
                <a-form-item label="培训标题">
                    <a-input class="search-input" placeholder="请输入" v-model="searchInfo.title" />
                </a-form-item>
                <a-form-item label="培训种类">
                    <a-select class="search-select" placeholder="请选择" v-model="searchInfo.type">
                        <a-select-option value="">全部</a-select-option>
                        <a-select-option v-for="item in trainTypeList" :key="item.id" :value="item.id">{{item.name}}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="培训日期">
                    <a-range-picker class="search-range-date" v-model="searchInfo.endDate" />
                </a-form-item>
                
                <a-form-item>
                    <a-button class="m-r-8" @click="search"><a-icon type="search" />查询</a-button>
                    <a-button @click="reset"><a-icon type="reload" />重置</a-button>
                </a-form-item>
            </a-form>
        </section>
        <section class="list-single-container" v-if="listMap.length">
            <a-row class="m-t-18 total-data-wrap">
                <a-col class="item">
                    <span class="key">培训总数：</span>
                    <span class="val">{{total}}</span>
                </a-col>
                <a-col class="item" v-for="(item,key) in statisticsData" :key="key">
                    <span class="key">{{item.name}}：</span>
                    <span class="val">{{item.count}}</span>
                </a-col>
                
            </a-row>
            <a-row class="list-border list-item m-t-18 list-item-image" v-for="(item,key) in listMap" :key="key">
                <a-row class="action-btn-group">
                    <a-row>
                        <!-- <router-link class="m-b-8" :to="{path:'/ssms/education/train/details',query:{id:item.id,companyName:item.companyName}}"><a-button size="small">查看</a-button></router-link> -->
                        <a-button size="small" class="m-b-8" @click="visible=true;trainId=item.id">查看</a-button>
                        <a-popconfirm @confirm="deleteItem(item.id)" title="确定删除该培训记录?"><a-button size="small">删除</a-button></a-popconfirm>
                    </a-row>
                </a-row>
                <a-row class="image-wrap">
                    <img :src="item.imageUrl" alt="">
                </a-row>
                <!-- <p>{{item.title}}</p> -->
                <p class="list-title"><span :title="item.title">{{(item.title && item.title.length > 50) ? (item.title.substring(0,50)+ '···'): item.title}}</span></p>
                <a-row class="m-b-10">
                    <a-col :span="7">
                        <span class="key">举办单位：</span>
                        <span class="val">{{item.companyName}}</span>
                    </a-col>
                    <a-col :span="7">
                        <span class="key">培训日期：</span>
                        <span class="val">{{item.dateStartTime}}</span>
                    </a-col>
                    <a-col :span="7">
                        <span class="key">参与人数：</span>
                        <span class="val">{{item.personCount}}</span>
                    </a-col>
                </a-row>
                <a-row class="m-b-10">
                    <a-col :span="7">
                        <span class="key">培训种类：</span>
                        <span class="val">{{item.typeName}}</span>
                    </a-col>
                    <a-col :span="7">
                        <span class="key">开始时间：</span>
                        <span class="val">{{item.startTime}}</span>
                    </a-col>
                    <a-col :span="7">
                        <span class="key">上传人：</span>
                        <span class="val">{{item.createByName}}</span>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="7">
                        <span class="key">培训地点：</span>
                        <span class="val" :title="item.addr">{{(item.addr && item.addr.length > 25) ? item.addr.substring(0,25)+ '···': item.addr}}</span>
                    </a-col>
                    <a-col :span="7">
                        <span class="key">结束时间：</span>
                        <span class="val">{{item.endTime}}</span>
                    </a-col>
                    <a-col :span="7">
                        <span class="key">上传时间：</span>
                        <span class="val">{{item.createTime}}</span>
                    </a-col>
                </a-row>
            </a-row>
        </section>
        <empty v-else :height="430" />
        <section class="pagination-container">
            <a-pagination 
            size="default" :current="pageNum" :total="total" :hideOnSinglePage="true" 
            :show-total="(total) => `共${total}条`"
            :showQuickJumper="true"
		    :showSizeChanger="false"
            @change="changePageNum" />
        </section>
        <!-- 详情 -->
        <a-modal title="培训详情" class="modal-container" v-model="visible" :width="1180" centered :destroyOnClose="true" :footer="false">
            <a-row class="scroll-container" style="max-height: 750px;overflow: hidden;overflow-y: auto"> 
                <trainDetails :trainId="trainId" />
            </a-row>
        </a-modal>

    </section>
</template>

<script>
import trainDetails from '../../../../ssms/education/train/details'
import empty from '@/components/empty'
export default {
    data(){
        return{
            total:0,
            pageNum:1,
            listMap:[],
            searchInfo:{
                endDate:[]
            },
            trainTypeList:[],
            statisticsData:[],
            visible:false,
            trainId:''
        }
    },
    components:{empty,trainDetails},
    props:['personnelId'],
    created(){
        this.init()
    },
    mounted(){
        this.querySafeEducationList()
        this.querySafeEducationStatistics()
    },
    computed:{
        picServer(){
            return this.$store.state.picServer
        }   
    },
    methods:{
        init(){
            this.querySafeEducationTypeList()
        },
        //培训类型
        querySafeEducationTypeList(){
            this.$api.querySafeEducationTypeList().then(res =>{
                if(res.code === 200){
                    this.trainTypeList = (res.data && res.data.records) || []
                }
            })
        },
        querySafeEducationStatistics(){
            this.$api.querySafeEducationStatistics({personnelId:this.personnelId}).then(res =>{
                if(res.code === 200){
                    this.statisticsData = res.data || []
                }
            })
        },
        querySafeEducationList(){
            let params = {...this.searchInfo}
            params.current = this.pageNum
            params.startDate = this.searchInfo.endDate.length ? this.searchInfo.endDate[0].format('YYYY-MM-DD') : ''
            params.endDate = this.searchInfo.endDate.length ? this.searchInfo.endDate[1].format('YYYY-MM-DD') : ''
            params.personnelId = this.personnelId
            this.$api.querySafeEducationList(params).then(res =>{
                if(res.code === 200){
                    this.listMap = (res.data && res.data.records) || []
                    this.total = (res.data && res.data.total) || 0
                    this.listMap.forEach(item =>{
                        item.photo = item.photo ? item.photo.split(',')[0] : ''
                        item.imageUrl = item.photo ? (item.photo.includes('http') ? item.photo : (this.picServer + item.photo)) : require('../../../../../assets/image/icon/default-image.png')
                        //item.imageUrl = item.photo.length ? JSON.parse(item.photo)[0].url : require('../../../../../assets/image/icon/default-image.png')
                    })
                }
            })
        },
        //重置
        reset(){
            this.searchInfo = {
                endDate:[]
            }
            this.pageNum = 1
            this.querySafeEducationList()
        },
        search(){
            this.pageNum = 1
            this.querySafeEducationList()
        },
        //分页
        changePageNum(p){
            this.pageNum = p
            this.querySafeEducationList()
        },
        //删除
        deleteItem(id){
            this.$api.deleteSafeEducation(id).then(res =>{
                if(res.code === 200){
                    this.querySafeEducationList()
                    this.querySafeEducationStatistics()
                }
            })
        }
    }
}
</script>